export enum PatientReportType {
  TREATMENT_SUMMARY = 'TREATMENT_SUMMARY',
}

export const PatientReportTypeLabels: Record<PatientReportType, string> = {
  [PatientReportType.TREATMENT_SUMMARY]: 'Treatment summary',
};
